import React, { useEffect } from "react";

export const UnauthTransaction = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container">
      <div className="termsPage">
        <h2 className="text-uppercase">
          Data Disclosure, Legal Action Policy & Unauthorized Transaction
        </h2>
        <p className="mb-3">
          If any unauthorized, fraudulent, or suspicious payment activity is
          detected on WaqarZaka.net, the platform reserves the right to
          investigate and take all necessary actions to protect its users and
          business.
        </p>
        <p className="mb-3">
          This includes — but is not limited to — the disclosure of information
          such as your name, contact details, login credentials, IP address, and
          payment data to law enforcement agencies, financial institutions, and
          relevant authorities for the purpose of fraud prevention,
          investigation, and prosecution.
        </p>
        <p className="mb-3">
          All disclosures will be made only as necessary and in full compliance
          with applicable data-protection and privacy laws (including GDPR,
          CCPA, and similar global regulations). WaqarZaka.net will never sell
          or disclose your information for profit, and maintains strict
          technical and organizational safeguards to protect user data.
        </p>
        <p className="mb-3">
          In cases of unauthorized use of payment methods, stolen cards, or
          fraudulent activity, WaqarZaka.net and its legal team reserve the
          right to initiate legal proceedings or file a case against the
          responsible party, either directly or through authorized
          representatives, in accordance with local and international law.
        </p>
        <p className="mb-3">
          By using this platform, you acknowledge and consent to these terms and
          understand that any unauthorized transaction constitutes a criminal
          and civil violation, which may result in account suspension, permanent
          ban, and legal action.
        </p>
      </div>
    </div>
  );
};
